export default class Columns {
    constructor(table) {
        this.table = table;
        this.columns = {};
        this.init();
    }
    init() {
        let self = this;
        let thead = this.table.querySelector('thead');
        let headers = thead.querySelectorAll('th');
        for (let i = 0; i < headers.length; i++) {
            let headerName = headers[i].id;
            self.columns[headers[i].id] = new ColumnTableSettings(headerName, AC.column_types[headerName], this.sanitizeLabel(headers[i]));
        }
    }
    getColumns() {
        return this.columns;
    }
    getColumnsMap() {
        let map = new Map();
        let columns = this.getColumns();
        Object.keys(columns).forEach((k) => {
            map.set(k, columns[k]);
        });
        return map;
    }
    getColumnNames() {
        return Object.keys(this.columns);
    }
    get(column_name) {
        return this.columns.hasOwnProperty(column_name) ? this.columns[column_name] : null;
    }
    sanitizeLabel(header) {
        let link = header.querySelector('a');
        let label = header.innerHTML;
        // If it contains a link, we presume that it is because of sorting
        if (link) {
            let elements = link.getElementsByTagName('span');
            if (elements.length > 0) {
                label = elements[0].innerHTML;
            }
        }
        return label;
    }
}
export class ColumnTableSettings {
    constructor(name, type, label) {
        this.name = name;
        this.type = type;
        this.label = label;
        this.services = {};
    }
    setService(name, service) {
        this.services[name] = service;
    }
    getService(name) {
        return this.hasService(name) ? this.services[name] : null;
    }
    hasService(name) {
        return this.services.hasOwnProperty(name);
    }
}
